import { render, staticRenderFns } from "./TemplateFileUploadGallery.vue?vue&type=template&id=82b4d240&scoped=true&"
import script from "./TemplateFileUploadGallery.vue?vue&type=script&lang=js&"
export * from "./TemplateFileUploadGallery.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFileUploadGallery.vue?vue&type=style&index=0&id=82b4d240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b4d240",
  null
  
)

export default component.exports